import Converter from '../Common/Converter'
import JSEncrypt from 'jsencrypt'


class CryptographyRsa {
    constructor(options) {
        this.jsEncrypt = new JSEncrypt(options);
        this.publicKey = "";
        this.privateKey = "";
    }

    /** 
     * @description 设置公钥
     * @param {String} publicKey 公钥
     */
    setPublicKey(publicKey) {
        let _self = this;
        if (publicKey) {
            _self.publicKey = publicKey;
            _self.jsEncrypt.setPublicKey(publicKey);
        }
    }

    /** 
     * @description 设置私钥
     * @param {String} privateKey 私钥
     */
    setPrivateKey(privateKey) {
        let _self = this;
        if (privateKey) {
            _self.privateKey = privateKey;
            _self.jsEncrypt.setPrivateKey(privateKey);
        }
    }

    /** 
     * @description 获取一个公钥
     * @returns 公钥
     */
    getPublicKey() {
        return this.jsEncrypt.getPublicKey();
    }

    /** 
     * @description 获取一个私钥
     * @returns 私钥
     */
    getPrivateKey() {
        return this.jsEncrypt.getPrivateKey();
    }

    /** 
     * @description 加密
     * @param {String} content 要加密的字符串
     * @param {String} publicKey 公钥
     * @return {Array} 加密后的Byte数组
     */
    encryptToBytes(content, publicKey) {
        let _self = this;
        _self.setPublicKey(publicKey);
        let resultArray = [];

        if (content && content.length > 0) {
            let count = Math.ceil(content.length / 240);
            for (let i = 0; i < count; i++) {
                let currentText = content.substr(i * 240, 240);
                let result = _self.jsEncrypt.encrypt(currentText);
                if (!result) console.error("Rsa加密失败");
                else resultArray = resultArray.concat(Converter.base64ToBytes(result));
            }
        }
        return resultArray;
    }

    /** 
     * @description 加密
     * @param {String} content 要加密的字符串
     * @param {String} publicKey 公钥
     * @return {String} 加密后Base64字符串
     */
    encryptToBase64(content, publicKey) {
        var encryptByteList = this.encryptToBytes(content, publicKey);
        return Converter.bytesToBase64(encryptByteList)
    }

    /** 
     * @description 解密
     * @param {String} content 要解密的Byte数组
     * @param {String} privateKey 私钥
     * @return {Array} 解密后的字符串
     */
    decryptBytes(contentBytes, privateKey) {
        let _self = this;
        _self.setPrivateKey(privateKey);
        let result = "";
        if (contentBytes && contentBytes.length > 0) {
            let count = Math.ceil(contentBytes.length / 256);
            for (let i = 0; i < count; i++) {
                let currentByte = contentBytes.slice(i * 256, 256);
                let currentDecryptResult = _self.jsEncrypt.decrypt(Converter.bytesToBase64(currentByte));
                if (!currentDecryptResult) console.error("Rsa解密失败");
                result = result + currentDecryptResult;
            }
        }
        return result;
    }

    /** 
     * @description 解密
     * @param {String} content 要解密文本
     * @param {String} privateKey 私钥
     * @return {Array} 解密后的字符串
     */
    decryptBase64(content, privateKey) {
        let _self = this;
        return this.decryptBytes(Converter.base64ToBytes(content), privateKey);
    }
}

export default new CryptographyRsa({
    default_key_size: 2048
});